<template>
  <div class="container">
    <template v-if="isMobile">
      <Moblie></Moblie>
    </template>
    <template v-else>
      <Computer></Computer>
    </template>
  </div>
</template>

<script>
import Computer from "./components/computer.vue";
import Moblie from "./components/moblie.vue";

export default {
  name: "index",
  components: {
    Computer,
    Moblie
  },
  data() {
    return {
      isMobile: true
    };
  },
  created() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },
};
</script>